export class change_passwordModel {
txtCurrentPass: string;
txtNewPass: string;
txtRePass: string;
setValue(res){
if(res){
if(res['txtCurrentPass']){this.txtCurrentPass = res['txtCurrentPass'];}
if(res['txtNewPass']){this.txtNewPass = res['txtNewPass'];}
if(res['txtRePass']){this.txtRePass = res['txtRePass'];}
}
}
}